<template>
  <dx-offer-intro product="b-business" />
</template>

<script>
import DxOfferIntro from '~/domains/offer/components/DX-OfferIntro'

export default {
  name: 'BBusinessIntro',
  components: {
    DxOfferIntro,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  transition: 'none',
  meta: {
    isPublic: true,
    trackingId: 'dextra.unternehmensrechtsschutz.b-business.antragsstrecke',
    trackingGroup: ['rechtsschutz', 'unternehmensrechtsschutz'],
  },
  nuxtI18n: {
    paths: {
      de: '/unternehmensrechtsschutz/b-business/antragsstrecke/',
      fr: '/protection-juridique-entreprise/b-business/formulaire-de-demande/',
    },
  },
}
</script>
